import { api } from "assets/scripts/utilities/api-clients";

function transformRole(data) {
  const { _id, name, code, description, applicable_to, permissions } = data;
  const transformed = {
    _id,
    name,
    code,
    description,
    applicable_to: [applicable_to],
    permissions: [],
  };

  for (const permissionGroup of permissions) {
    for (const useCase of permissionGroup.useCases) {
      transformed.permissions.push({
        usecase: useCase.usecase,
        permissions: useCase.permissions,
        module: useCase.module,
      });
    }
  }

  return transformed;
}

function transformUser(data) {
  const { _id, permissions, role } = data;
  const transformed = {
    _id,
    permissions: [],
    role: [role],
  };

  for (const permissionGroup of permissions) {
    for (const useCase of permissionGroup.useCases) {
      transformed.permissions.push({
        usecase: useCase.usecase,
        permissions: useCase.permissions,
        module: useCase.module,
      });
    }
  }

  return transformed;
}

export const index = async (options) => {
  const response = await api.get(`/admin/roles`, options);

  return response;
};

export const get = async (id) => {
  const response = await api.get(`/admin/roles/permissions/${id}`);

  return response;
};

export const post = async (role) => {
  const response = await api.post("/admin/roles", transformRole(role));

  return response;
};

export const put = async (role) => {
  const response = await api.put(
    `/admin/roles/${role._id}`,
    transformRole(role),
  );

  return response;
};

export const deleteRole = async (id) => {
  const response = await api.delete(`/admin/roles/${id}`);

  return response;
};

export const getInitialPermissions = async () => {
  const response = await api.get(`/admin/roles/permissions`);

  return response;
};

export const getRolePermissions = async (userId) => {
  const response = await api.get(
    `/admin/roles/users/rolesAndPermission?userId=${userId}`,
  );

  return response;
};

export const putRolePermissions = async (user) => {
  const response = await api.put(
    `/admin/roles/users/update/${user._id}`,
    transformUser(user),
  );

  return response;
};

export const getValidations = async (id) => {
  const response = await api.get(`/admin/roles/roleValidation/${id}`);

  return response;
};

export const getUserRoles = async (options) => {
  const response = await api.get(`/kam/users/getRoles`, options);

  return response;
};

export const getPermissions = async (roleId) => {
  const response = await api.get(`/kam/users/getRolesPermission/${roleId}`);

  return response;
};
